import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AcbuySpreadsheetGuide from "../pages/acbuy-spreadsheet-guide/page";
import AcbuySpreadsheetExplained from "../pages/acbuy-spreadsheet-explained/page";
import AcbuySpreadsheetDeals from "../pages/acbuy-spreadsheet-deals/page";
import AcbuySpreadsheetReview2026 from "../pages/acbuy-spreadsheet-review-2026/page";
import AcbuySpreadsheetVsAmazon from "../pages/acbuy-spreadsheet-vs-amazon/page";
import AcbuySpreadsheetTrend2026 from "../pages/acbuy-spreadsheet-trend-2026/page";
import AcbuySpreadsheetBeginners from "../pages/acbuy-spreadsheet-beginners/page";
import AcbuySpreadsheetSafe from "../pages/acbuy-spreadsheet-safe/page";
import AcbuySpreadsheetBestProducts from "../pages/acbuy-spreadsheet-best-products/page";
import AcbuySpreadsheetSaveMoney from "../pages/acbuy-spreadsheet-save-money/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/acbuy-spreadsheet-guide",
    element: <AcbuySpreadsheetGuide />,
  },
  {
    path: "/acbuy-spreadsheet-explained",
    element: <AcbuySpreadsheetExplained />,
  },
  {
    path: "/acbuy-spreadsheet-deals",
    element: <AcbuySpreadsheetDeals />,
  },
  {
    path: "/acbuy-spreadsheet-review-2026",
    element: <AcbuySpreadsheetReview2026 />,
  },
  {
    path: "/acbuy-spreadsheet-vs-amazon",
    element: <AcbuySpreadsheetVsAmazon />,
  },
  {
    path: "/acbuy-spreadsheet-trend-2026",
    element: <AcbuySpreadsheetTrend2026 />,
  },
  {
    path: "/acbuy-spreadsheet-beginners",
    element: <AcbuySpreadsheetBeginners />,
  },
  {
    path: "/acbuy-spreadsheet-safe",
    element: <AcbuySpreadsheetSafe />,
  },
  {
    path: "/acbuy-spreadsheet-best-products",
    element: <AcbuySpreadsheetBestProducts />,
  },
  {
    path: "/acbuy-spreadsheet-save-money",
    element: <AcbuySpreadsheetSaveMoney />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;